import { Either } from "../../core/types/Either";
import { FlexProduct } from "../entity/FlexPackage";

export abstract class FlexPackageRepository {
  abstract getProducts(
    appPid?: number,
    packageId?: string
  ): Promise<Either<Error, FlexProduct[]>>;
}
